import React from "react";
import { CloseIcon } from "../../assets/icons/icons";
import "./style.css"; // You can create or reuse a CSS file for styling

/**
 * Example instructions text based on your screenshot and description.
 * Feel free to modify or replace with the exact content you want to display.
 */
const instructionsText = `
Your athlete experiences of their environment cross the focus of sport season, sport division, competition level, staff turnover, organizational flow and more. 
It’s important to learn from each athletic demographic throughout their sport year.

Use the recognition campaign to observe your athletes’ experiences and get specific data. 
Then compare your data results across time and across categories. 
This can help your leadership team identify areas to improve or celebrate within your organization.

Who to send campaigns to?
Recognition Campaign is available to Athletes and sports participants actively involved with your organization for the given season, age, or categorical issue such as sport division, competition level, sport reason, etc. 
We suggest that you consult with your leadership team to establish appropriate scope for your organization’s CDM.

Do not wait until:
• Waiting athletes
• Athletes are physically done with the sport
• High-level concerns go unreported
• Or your athletes feel that your environment did not have time to enact or extend a chance.

When to send out Recognition Campaign?
Recognition Campaigns are designed for detection without limitation. 
Common schedule considerations:
• Pre-season introduction or re-engagement after registration to inspire readiness.
• Mid-season check
• Monthly cadence (quarterly also possible) to track changes in the voices of repeat respondents.
• Season end review

How to send out a Recognition Campaign?
Use the Lasso Safe platform to create the link, and you will be advised of information for your campaign's CDM.
You may want to specifically share the campaign link by email or other communication methods to your athlete population, emphasizing that this is a mentoredly secured and protected system.
We encourage you to keep a watchful eye for athlete completion. The earlier you gather the results, the faster you can respond. This could be a good time to offer your athletes an in-person or digital “office hour” to talk about the new changes, if they want to.
`;

export default function InstructionsModal({ isOpen, closeModal }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay-fullscreen" onClick={closeModal}>
      <div className="modal-content-fullscreen" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-fullscreen">
          <h2>Athlete Experience Recognition Evaluation Instructions</h2>
          <CloseIcon onClick={closeModal} className="cancel-icon" />
        </div>

        <div className="instructions-body">
          {/* You can further format or break up this text into paragraphs, lists, etc. */}
            <p>
              Your athletes' experiences of their environment ebbs and flows by sport season, sport division, competition level, staff turnover, organizational reform and more. It's important to learn from each athletic demographic throughout their sport year.
            </p>

            <p>
              Use the recognition campaign to label a survey send-out and categorize the resulting data. Then compare your newest data trends with your previous campaigns to recognize patterns unique to your environment and inform learning module selection.
            </p>

            <h3>Who do I send campaigns to?</h3>
            <p>
              You can send out a Recognition Campaign to all athletes and sports participants currently involved with your organization age twelve years and up, or categorize lists based on sport division, competition level, sport season and more. We suggest that you consult with your leadership team to establish campaign contact lists on your organization's CRM.
            </p>

            <h4>Do not send the evaluation to:</h4>
            <ul>
              <li>Visiting athletes</li>
              <li>Athletes no longer involved in your organization</li>
              <li>Athletes who do not have a feel of your current environent due to recent intake or extended absence.</li>
            </ul>

            <h3>When do I send out a Recognition Campaign?</h3>
            <p>
              Recognition Campaigns can be scheduled at your discretion without limitation.
            </p>
            <p><strong>Common schedule considerations are:</strong></p>
            <ul>
              <li>Attach the campaign to a membership or event registration to require response.</li>
              <li>Seasonal: monitor athlete experiences around their sport season.</li>
              <li>Monthly: build consistent data to review year-over-year.</li>
              <li>Athlete responsiveness (too often or too little can affect the interest of athletes).</li>
            </ul>

            <h3>How do I send out a Recognition Campaign?</h3>
            <p>
              <strong>1.</strong> Using the form in the New Evaluation tab, enter the title and required information of your campaign
            </p>
            <p>
              <strong>2.</strong> Next, a unique survey link will be generated. Copy the link to insert into your campaign email via your organization's CRM. You may want to require participation by attaching it to a membership renewal or event registration.<br/>
            </p>
            <p>
              <strong>3.</strong> Create email content to introduce the campaign to your athletes. Use this as an opportunity to let them know that their voice matters and engage them in quality feedback. If you have applied learning modules in response to a previous campaign, this could be a good time to let your athletes know and encourage them to participate in change-making again. Feel free to copy and paste our suggested content as a starting point.<br/>
            </p>
            <p>
              <strong>4.</strong> If you have a campaign schedule, you may want to let them know when to expect the next one.
            </p>
        </div>
      </div>
    </div>
  );
}
